import React, { useState, useEffect } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import './Toast.css';

const Toast = ({ message, type, onDismiss }) => {
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsExiting(true);
            setTimeout(onDismiss, 300); // Allow animation to complete before removal
        }, 5000);

        return () => clearTimeout(timer);
    }, [onDismiss]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return 'check circle';
            case 'error':
                return 'times circle';
            case 'warning':
                return 'exclamation circle';
            case 'info':
                return 'info circle';
            default:
                return 'bell';
        }
    };

    const getMessageProps = () => {
        switch (type) {
            case 'success':
                return { positive: true };
            case 'error':
                return { negative: true };
            case 'warning':
                return { warning: true };
            case 'info':
                return { info: true };
            default:
                return {};
        }
    };

    return (
        <Message
            {...getMessageProps()}
            onDismiss={() => {
                setIsExiting(true);
                setTimeout(onDismiss, 300);
            }}
            className={isExiting ? 'fade-out' : ''}
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Icon name={getIcon()} size="large" style={{ marginRight: '10px' }} />
                <div style={{ flex: 1 }}>{message}</div>
            </div>
        </Message>
    );
};

export default Toast;
